import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'

import { LoginStrategy } from '@/types'
import * as ModalTypes from '../../components/App/Modal/constants'
import * as ActionTypes from '../actions'

export const addReaction = (payload) => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.COMMIT_PROJECT_REQUEST,
    payload: [
      {
        type: ActionTypes.ADD_REACTION,
        payload,
      },
    ],
  })
}

export const clearSelectedBlocks = () => (dispatch) => {
  dispatch({
    type: CanvasActionTypes.CLEAR_SELECTED_BLOCKS,
  })
}

export const loginStrategy = (payload) => (dispatch, getState) => {
  const { ui, canvas } = getState()
  const { modalProps } = ui
  const projectId = migrationProjectSelector.getProjectId(getState())
  const { activeTab } = canvas.tabs

  let redirectAfterAuth = null

  switch (payload.type) {
    case LoginStrategy.MODAL_BLOCK: {
      if (projectId) {
        redirectAfterAuth = `/${projectId}/${activeTab}/b/${modalProps.id}/note`
      }

      break
    }
    case LoginStrategy.MODAL_COMMENTS: {
      if (projectId) {
        redirectAfterAuth = `/${projectId}/${activeTab}/p/${modalProps.commentable}/comments`
      }

      break
    }
    default: {
      break
    }
  }

  dispatch({
    type: ActionTypes.OPEN_MODAL,
    payload: {
      modalType: ModalTypes.MODAL_AUTH,
      modalProps: {
        redirectAfterAuth,
      },
    },
  })
}
